/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SrsClientConfigDto } from '../../models/srs-client-config-dto';

export interface GetLatestConfig$Params {
}

export function getLatestConfig(http: HttpClient, rootUrl: string, params?: GetLatestConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<SrsClientConfigDto>> {
  const rb = new RequestBuilder(rootUrl, getLatestConfig.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SrsClientConfigDto>;
    })
  );
}

getLatestConfig.PATH = '/api/srsc/getLatestConfig';
